<template>
  <div>
    <el-upload
      class="mb10 text-right"
      action="string"
      :before-upload="handleBeforeUpload"
      :show-file-list="false"
      :http-request="handleUploadFile"
    >
      <crm-button
        v-if="
                  contractAuth.contractUploadFile &&
                  contractAuth.contractUploadFile.toggleStatus
                "
        :buttonType="'secondary'"
        :size="'mini'"
        :text="'上传附件'"
      >
        <el-tooltip
          content="图片文件单个不能超过5M;其他文件单个不能超过50M"
          class="item"
          effect="dark"
          placement="top"
        >
          <span class="el-icon-question" style="font-size: 16px"></span>
        </el-tooltip>
      </crm-button>
    </el-upload>
    <el-table
      :data="compactFileData.results"
      v-loading="fileLoading"
      class="tab-table-item"
      style="width: 100%; height: calc(100vh - 357px);"
    >
      <el-table-column prop="creatorName" label="操作人" align="center">
      </el-table-column>
      <el-table-column
        prop="gmtCreatedStr"
        label="上传时间"
        width="180"
        align="center"
      >
      </el-table-column>
      <el-table-column
        show-overflow-tooltip
        prop="fileUrl"
        label="附件"
        align="center"
      >
        <template slot-scope="scope">
          <a
            v-if="
                      contractAuth.contractFilePreview &&
                      contractAuth.contractFilePreview.toggleStatus &&
                      scope.row.previewUrl
                    "
            href="javascript:;"
            @click="getFildUrl(scope.row)"
          >
            {{ scope.row.fileName }}
          </a>
          <span v-else>{{ scope.row.fileName || "暂无数据" }}</span>
        </template>
      </el-table-column>
      <el-table-column width="100" label="操作" align="center">
        <template slot-scope="scope">
          <a
            v-if="
                      contractAuth.contractFileDownload &&
                      contractAuth.contractFileDownload.toggleStatus &&
                      scope.row.fileUrl
                    "
            :href="scope.row.fileUrl"
          >
            下载
          </a>
        </template>
      </el-table-column>
    </el-table>
    <div class="pageination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="fileData.pageNumber"
        :page-sizes="[5, 10, 20]"
        :page-size="fileData.pageSize"
        layout="total, sizes, prev, pager, next"
        :total="compactFileData.totalCount"
      >
      </el-pagination>
    </div>
    <el-image-viewer
      v-if="imagePreview.showImage"
      :on-close="closeViewer"
      :url-list="[...imagePreview.url]"
    />
  </div>
</template>

<script>
import CrmButton from "~component/base/crmButton";
import { mapActions, mapGetters } from 'vuex'
import { uploadFileVerify } from '@/scripts/reg'

export default {
  components: {
    CrmButton,
    "el-image-viewer": () => import("element-ui/packages/image/src/image-viewer"),
  },
  filters: {},
  props: {
    id: String,
  },
  data() {
    return {
      fileLoading: false,
      isRefresh: false,
      fileData: {
        pageNumber: 1,
        pageSize: 5,
      },
      imagePreview: {
        showImage: false,
        url: "",
      },
    }
  },
  computed: {
    ...mapGetters({
      contractAuth: "authority/contractAuth",
      compactFileData: "compact/compactFileData",
    }),
  },
  watch: {},
  methods: {
    ...mapActions({
      uploadCompactFile: "compact/uploadCompactFile",
      getCompactFileList: "compact/getCompactFileList",
    }),
    handleSizeChange(value) {
      this.fileData.pageSize = value
      this.fileData.pageNumber = 1
      this.queryList()
    },
    handleCurrentChange(value) {
      this.fileData.pageNumber = value
      this.queryList()
    },
    async handleBeforeUpload(file) {
      /* eslint-disable */
      const isLt2M = file.size / 1024 / 1024 < 50;

      if (!isLt2M) {
        this.$message.error("上传文件大小不能超过 50MB!");
        return Promise.reject();
      }

      try {
        return await uploadFileVerify(file.name);
      } catch (e) {
        this.$message(e);
        return Promise.reject();
      }
    },
    // 附件表格
    handleUploadFile(item) {
      this.notify = this.$notify({
        iconClass: "el-icon-loading",
        title: "",
        message: "正在上传中，请稍后...",
        duration: 0,
        showClose: false,
      });
      const params = new FormData();
      params.append("file", item.file);
      params.append("fileName", item.file.name);
      params.append("bizUid", this.id);
      this.uploadCompactFile({
        params,
        config: { "Content-Type": "multipart/form-data", timeout: 100000 },
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "上传成功！",
          });
          this.queryList();
          this.isRefresh = true;
        })
        .finally(() => {
          if (this.notify) this.notify.close();
        });
    },
    queryList() {
      this.fileLoading = true;
      const { pageSize, pageNumber } = this.fileData;
      this.getCompactFileList({
        bizUid: this.id,
        pageSize,
        pageNumber,
      }).finally(() => {
        if (this.compactFileData.results.length === 0 && pageNumber !== 1) {
          this.fileData.pageNumber = 1;
          this.queryList();
        } else {
          this.fileLoading = false;
        }
      });
    },
    getFildUrl(row) {
      this.imagePreview.url = "";
      const typeArr = row.fileName.split(".");
      if (["png", "jpg", "jpeg"].includes(typeArr[typeArr.length - 1])) {
        this.imagePreview.url = row.previewUrl;
        this.imagePreview.showImage = true;
        this.stopMove();
        return;
      }
      if (typeArr[typeArr.length - 1] === "pdf") {
        window.open(row.previewUrl);
        return;
      }
      const url = this.htmlDecodeByRegExp(row.fileUrl);
      window.open(`https://view.officeapps.live.com/op/view.aspx?src=${url}`);
    },
    // 停止页面滚动
    stopMove() {
      const m = (e) => {
        e.preventDefault();
      };
      document.body.style.overflow = "hidden";
      document.addEventListener("touchmove", m, { passive: false }); // 禁止页面滑动
    },
    htmlDecodeByRegExp(str) {
      var s = "";
      if (str.length === 0) return "";
      s = str.replace(/&amp;/g, "&");
      s = s.replace(/&lt;/g, "<");
      s = s.replace(/&gt;/g, ">");
      s = s.replace(/&nbsp;/g, " ");
      s = s.replace(/&#39;/g, "'");
      s = s.replace(/&quot;/g, '"');
      return s;
    },
    // 关闭图片预览
    closeViewer() {
      this.imagePreview.showImage = false;
      this.move();
    },
    // 开启页面滚动
    move() {
      const m = (e) => {
        e.preventDefault();
      };
      document.body.style.overflow = "auto"; // 出现滚动条
      document.removeEventListener("touchmove", m, { passive: true });
    },
  },
}
</script>
